<div>
  @if (label) {
    <label class="tt-color-picker_label">{{ label }}:</label>
  }
  <div class="tt-color-picker_input">
    <input type="color" [(ngModel)]="selectedColor" (change)="onColorChange($event)" />
    <span>{{ selectedColor }}</span>
  </div>
</div>
